module.exports = __webpack_public_path__ + "ru.png?05adc53240585c179858249e9a3dd08b";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/ru.png
// module id = 446
// module chunks = 0